import React from 'react';
import PropTypes from 'prop-types';

const CheckmarkIcon = ({ className }) => (
	<svg className={className} style={{ minWidth: '16px' }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 8L7 11L13 5" stroke="#00AE4F" strokeWidth="2"/>
	</svg>
);

CheckmarkIcon.propTypes = {
	className: PropTypes.string,
};

CheckmarkIcon.defaultProps = {
	className: '',
};

export default CheckmarkIcon;
